import { render, staticRenderFns } from "./PlotChange.vue?vue&type=template&id=5ea5a4e2&scoped=true"
import script from "./PlotChange.vue?vue&type=script&lang=ts"
export * from "./PlotChange.vue?vue&type=script&lang=ts"
import style0 from "./PlotChange.vue?vue&type=style&index=0&id=5ea5a4e2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea5a4e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ea5a4e2')) {
      api.createRecord('5ea5a4e2', component.options)
    } else {
      api.reload('5ea5a4e2', component.options)
    }
    module.hot.accept("./PlotChange.vue?vue&type=template&id=5ea5a4e2&scoped=true", function () {
      api.rerender('5ea5a4e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/PlotChange.vue"
export default component.exports